<template>
       <div class="FileManager">
        <div class="FileManager-menu">
            <div class="FileManager-menu-breadcrumb">
                <Breadcrumb></Breadcrumb>
            </div>
            <div class="FileManager-menu-btn">
            </div>
        </div>
        <div class="FileManager-content">
            <div class="FileManager-content-btn">
                <div style="display: flex; justify-content: flex-end;gap: 10px;">
                    <el-button type="primary" size="small" @click="retreat" icon="el-icon-back" plain>后退</el-button>
                    <el-button type="primary" size="small" @click="getFileList(tableData.path)" icon="el-icon-refresh"
                        style="margin-left: 0;" plain>刷新</el-button>
                    <folderUpdat :datas="tableData" @refresh="refresh"></folderUpdat>
                    <openFolder :datas="tableData" @refresh="refresh"></openFolder>
                    <el-button size="small" :disabled="selectData.length === 0" @click="handleDelete(selectData, 'all')"
                        type="danger" icon="el-icon-delete" plain>删除</el-button>
                </div>
                <div style="user-select: none;flex:1">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item>
                            <span style="color: #868d9c;">文件管理</span>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(item, index) in tableData.breadcrumb" :key="index">
                            <span class="breadcrumbs-item" @click="handleClick(item)">{{ item.name }}</span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div
                    style="flex-shrink: 0;width: 180px;display: flex;flex-direction: column;gap: 5px;user-select: none;">
                    <span style="color: #575c65;font-size: 12px;font-weight: bold;">存储容量</span>
                    <el-progress :color="customColors" :percentage="storageInfo.usage_percentage"
                        :show-text="false"></el-progress>
                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <span style="color: #8a92a2;font-size: 12px;letter-spacing: 1px;">
                            {{ storageInfo.used_storage_formatted }}/{{ storageInfo.storage_limit_formatted }}</span>
                        <span style="color: #8a92a2;font-size: 12px;">
                            {{ storageInfo.usage_percentage.toFixed(2) }}%</span>
                    </div>
                </div>
            </div>
            <div class="FileManager-content-table">
                <!-- :default-sort="{ prop: 'time', order: 'descending' }" 默认时间降序 -->
                <el-table ref="fileTable" :data="tableData.Data" v-loading="loading" :row-key="(row) => row.id"
                    style="width: 100%" size="mini" tooltip-effect="light" @selection-change="handleSelectionChange">
                    <template slot="empty">
                        <el-empty description="文件夹为空"></el-empty>
                    </template>
                    <el-table-column type="selection" width="45" :reserve-selection="true"></el-table-column>
                    <el-table-column label="文件名" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div @click="handleClick(scope.row)"
                                style="cursor: pointer;display: flex;align-items: center;">
                                <img :src="getIconByUrl(scope.row)" style="width: 20px;">
                                <span style="margin: 5px 0 0 8px;">{{ scope.row.t_name }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fileNum" label="大小" sortable :sort-method="sortBySize">
                        <template slot-scope="scope">
                            <div>{{ scope.row.t_size_format }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="filetype" label="类型">
                        <template slot-scope="scope">
                            <div>{{ scope.row.t_type }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="修改时间" sortable :sort-method="sortByTime">
                        <template slot-scope="scope">
                            <div>{{ scope.row.update_time }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="small" @click="handleRename(scope.row)" type="text">重命名</el-button>
                            <el-button size="small" @click="handleDelete([scope.row], 'single')"
                                type="text">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="FileManager-content-pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="initForm.page" :page-size="initForm.page_z" layout="total, prev, pager, next, jumper"
                    :total="tableData.Num">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="阅览" :fullscreen="!FileFlag" width="200px" :visible.sync="innerDialogVisible"
            :append-to-body="true">
            <el-image v-if="FileFlag" style="width: 100px; height: 100px" :src="FileUrl" :preview-src-list="[FileUrl]">
            </el-image>
            <embed v-else :src="FileUrl" width="100%" style="height: calc(100vh - 120px);" />
        </el-dialog>
    </div>
</template>

<script>
import { allFileManager, renameFileManager, deleteFileManager, storageInfo } from '@/api/FileManager.js'
import openFolder from './FileManager_modules/openFolder.vue'
import folderUpdat from './FileManager_modules/folderUpdat.vue'


export default {
    name: "",
    components: {
        openFolder, folderUpdat
    },
    data() {
        return {
            customColors: [
                { color: '#409eff', percentage: 60 },
                { color: '#e6a23c', percentage: 95 },
                { color: '#f56c6c', percentage: 100 },
            ],
            storageInfo: {
                used_storage_formatted: '0GB',
                storage_limit_formatted: '0GB',
                usage_percentage: 0,
            },
            innerDialogVisible: false,
            drawer: false,
            tableData: {},
            selectData: [],
            loading: false,
            prevPath: [],//上一个path
            initForm: {
                page: 1,
                page_z: 10,
            },
            FileUrl: '',
            FileFlag: false,//false显示图片 true显示iframe
        }
    },
    mounted() {
        this.getFileList();
    },
    methods: {
        //获取存储信息
        getStorageInfo() {
            storageInfo({}).then(({ data: res }) => {
                if (res.Code === 200) {
                    this.storageInfo = res.Data;
                }
            })
        },
        // 按文件大小排序
        sortBySize(a, b) {
            // 从格式化的大小字符串中提取数值和单位
            function getSizeValue(sizeStr) {
                if (!sizeStr || sizeStr === '-') return 0;

                const match = sizeStr.match(/^(\d+(\.\d+)?)\s*(B|KB|MB|GB|TB)?$/i);
                if (!match) return 0;

                let size = parseFloat(match[1]);
                const unit = (match[3] || 'B').toUpperCase();

                // 转换为字节进行比较
                switch (unit) {
                    case 'KB': size *= 1024; break;
                    case 'MB': size *= 1024 * 1024; break;
                    case 'GB': size *= 1024 * 1024 * 1024; break;
                    case 'TB': size *= 1024 * 1024 * 1024 * 1024; break;
                }

                return size;
            }

            return getSizeValue(a.t_size_format) - getSizeValue(b.t_size_format);
        },

        // 按时间排序
        sortByTime(a, b) {
            // 假设 update_time 是标准的时间字符串或时间戳
            const timeA = new Date(a.update_time).getTime();
            const timeB = new Date(b.update_time).getTime();
            return timeA - timeB;
        },
        //后退
        retreat() {
            if (this.prevPath.length > 0) {
                this.selectData = [];
                // 主动清除表格的选择状态
                if (this.$refs.fileTable) {
                    this.$refs.fileTable.clearSelection();
                }
                this.initForm.page = 1;
                this.getFileList(this.prevPath.pop());
            }
        },
        //刷新文件列表
        refresh() {
            this.selectData = [];
            // 主动清除表格的选择状态
            if (this.$refs.fileTable) {
                this.$refs.fileTable.clearSelection();
            }
            this.getFileList(this.tableData.path);
        },
        //获取文件列表
        getFileList(path = '/') {
            this.loading = true;
            allFileManager({
                ...this.initForm,
                path: path,
            }).then(({ data: res }) => {
                if (res.Code === 200) {
                    res.Data.Data = res.Data.Data || [];
                    // 文件夹排在前面
                    res.Data.Data.sort((a, b) => {
                        return (b.t_type === '文件夹') - (a.t_type === '文件夹') ||
                            a.t_name.localeCompare(b.t_name);
                    });
                    this.tableData = res.Data || {};
                    this.getStorageInfo();
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
                this.$message.error('获取文件列表失败');
            })
        },

        //重命名
        handleRename(row) {
            this.$prompt('请输入重命名的名称', '重命名', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\S+$/, // 修改为不能为空且不能包含空格
                inputErrorMessage: '重命名的名称不能为空且不能包含空格',
                inputValue: row.t_name,
            }).then(({ value }) => {
                // 调用重命名接口
                renameFileManager({
                    oldName: row.t_path,
                    newName: value,
                }).then(({ data: res }) => {
                    if (res.Code === 200) {
                        this.$message.success('重命名成功');
                        this.getFileList();
                    }
                }).catch((err) => {
                    this.$message.error('重命名失败');
                });
            }).catch(() => { });
        },
        //删除
        handleDelete(row, type) {
            this.$confirm(`确定删除${type == 'all' ? '选中的' : ''}文件吗？`, '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                for (let index = 0; index < row.length; index++) {
                    const element = row[index];
                    await deleteFileManager({ path: element.t_path });
                }
                this.$message.success('删除成功');
                this.initForm.page = 1;
                this.refresh();
            }).catch(() => { });
        },

        //点击行打开文件夹
        handleClick(row) {
            this.prevPath.push(this.tableData.path);
            let path = row.t_path || row.path;
            if (path == this.tableData.path) return;
            if (row.t_type == '文件夹' || row.path) {
                this.selectData = [];
                // 主动清除表格的选择状态
                if (this.$refs.fileTable) {
                    this.$refs.fileTable.clearSelection();
                }
                this.initForm.page = 1;
                this.getFileList(path);
            } else {
                if (['xlsx文件', 'xls文件', 'docx文件', 'doc文件'].includes(row.t_type)) {
                    this.FileUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${row.t_url}`;
                    this.FileFlag = false;
                } else {
                    this.FileFlag = (row.t_type == 'pdf文件' ? false : true);
                    this.FileUrl = row.t_url
                }
                this.innerDialogVisible = true;

            }
        },
        handleSizeChange(val) {
            this.initForm.page_z = val;
            this.getFileList(this.tableData.path);
        },
        handleCurrentChange(val) {
            this.initForm.page = val;
            this.getFileList(this.tableData.path);
        },
        //勾选
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // 根据文件类型返回对应的本地图标
        getIconByUrl(row) {
            let fileType = row.t_type;
            // 根据文件类型返回对应的本地图标
            if (fileType == '文件夹') {
                return require('@/assets/img/folder.png');
            } else if (['jpg文件', 'jpeg文件', 'png文件', 'gif文件'].includes(fileType)) {
                return require('@/assets/img/tupian.png');
            } else if (['doc文件', 'docx文件'].includes(fileType)) {
                return require('@/assets/img/word.png');
            } else if (['xls文件', 'xlsx文件'].includes(fileType)) {
                return require('@/assets/img/excel.png');
            } else if (['pdf文件'].includes(fileType)) {
                return require('@/assets/img/PDF.png');
            }
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep .el-table-column--selection .cell {
    padding-left: 14px !important;
    padding-right: 14px !important;
}
</style>
<style lang="scss">
.breadcrumbs-item {
    color: #868d9c;
}

.breadcrumbs-item:hover {
    color: #409eff;
    cursor: pointer;
}

.FileManager {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    &-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(#fff, 1);
        height: 70px;
        padding: 15px 10px;
        box-shadow: 5px 5px 10px -10px #000;

        &-breadcrumb {
            padding-left: 20px;
        }

        &-btn {
            padding-right: 20px;
        }
    }

    &-content {
        flex: 1;
        padding: 20px;
        overflow-y: auto;

        &-btn {
            display: flex;
            align-items: center;
            gap: 20px;
        }

        &-table {
            margin-top: 10px;
        }

        &-pagination {
            margin-top: 30px;
        }
    }



}
</style>